import { useCallback } from 'react'
import type { ApiError } from '@/api/types'
import { useToast } from './useToast'

export function useApiErrorToast() {
  const { addToast } = useToast()

  return useCallback((error: ApiError) => {
    // Отдаем приоритет failures
    const failureText = error.failures?.map((f) => `[${f.id}] ${f.description}`).join(', ')

    const fallbackText = error.message || 'Произошла неизвестная ошибка'

    addToast('Ошибка!', failureText || fallbackText, 'error')
  }, [])
}
